import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  root: {
    flexDirection: 'column',
    paddingVertical: 6,
  },
});
